import React from "react";
import Page from "../Page";
import Contact from "../Contact";

const ContactPage = () => (
  <Page>
    <Contact />
  </Page>
);

export default ContactPage;
